/**
 * PaymentProofFilters Component
 * Filter controls for payment proofs
 */

import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select, { type SelectOption } from "../../../components/ui/Select";

interface PaymentProofFiltersProps {
	filters: {
		status: string;
		search: string;
	};
	onFilterChange: (filters: { status?: string; search?: string }) => void;
}

const PaymentProofFilters: React.FC<PaymentProofFiltersProps> = ({
	filters,
	onFilterChange,
}) => {
	const statusOptions: SelectOption[] = [
		{ value: "", label: "All Statuses" },
		{ value: "pending", label: "Pending" },
		{ value: "approved", label: "Approved" },
		{ value: "rejected", label: "Rejected" },
	];

	const handleClearFilters = () => {
		onFilterChange({ status: "", search: "" });
	};

	return (
		<div className="bg-card border border-border rounded-lg p-4 sm:p-6">
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				{/* Search */}
				<div className="md:col-span-2">
					<Input
						label="Search"
						placeholder="Search by transaction reference, payment method..."
						value={filters.search}
						onChange={(e) => onFilterChange({ search: e.target.value })}
					/>
				</div>

				{/* Status Filter */}
				<Select
					label="Status"
					value={filters.status}
					onValueChange={(value) => {
						const selectedValue = Array.isArray(value) ? value[0] : value;
						onFilterChange({ status: String(selectedValue) });
					}}
					options={statusOptions}
				/>
			</div>

			{/* Clear Filters Button */}
			{(filters.status || filters.search) && (
				<div className="mt-4 flex justify-end">
					<Button variant="outline" size="sm" onClick={handleClearFilters}>
						<Icon name="X" size={16} className="mr-2" />
						Clear Filters
					</Button>
				</div>
			)}
		</div>
	);
};

export default PaymentProofFilters;
